import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { PageNumberInfo } from 'shared/ui/PageNumberInfo/PageNumberInfo'
import { ClientDetails } from 'pages/clients/pages/create/ui/ClientDetails/ClientDetails'
import { ChoosePlan } from 'pages/clients/pages/create/ui/ChoosePlan/ChoosePlan'
import { useCreateContext } from 'pages/clients/pages/create/context/createContext'
import { Checkout } from 'pages/clients/pages/create/ui/Checkout/Checkout'
import styles from './styles.module.scss'

export const CreatePage = observer(() => {
  const {
    currentStep,
    totalSteps,
    isContainerWide,
    clientDetailsStore: { isDuplicateTableAction },
  } = useCreateContext()

  return (
    <div
      className={classNames(styles.container, {
        [styles.containerStepNarrow]: !isContainerWide,
        [styles.containerStepWide]: isContainerWide,
      })}
    >
      <div className={styles.pageNumberInfoContainer}>
        <PageNumberInfo
          currentStep={currentStep}
          totalSteps={totalSteps}
          title={isDuplicateTableAction ? 'Duplicate' : 'New client'}
        />
      </div>
      {currentStep === 1 && <ClientDetails />}
      {currentStep === 2 && <ChoosePlan />}
      {currentStep === 3 && <Checkout />}
    </div>
  )
})
